import Sortable from "sortablejs"

// makes the items of `list` reorderable by dragging their handles (`item` and
// `handle` are CSS selectors, as Sortable takes them). After a drop, calls
// `onReorder(ids, restore)` with `ids()` (the items' ids in their rendered
// order) moved to the new order, and `restore()` putting the dropped item back
// (e.g. when the server rejects the order). `items()` returns the item nodes
// in their rendered order (the hook's targets, not yet updated at the drop).
// Returns the Sortable instance, which must be `destroy()`ed with the hook
export function createSortableList(
  list,
  { item, handle, draggingClass, ids, items, onReorder }
) {
  const reducedMotion = window.matchMedia(
    `(prefers-reduced-motion: reduce)`
  ).matches

  return Sortable.create(list, {
    draggable: item,
    handle,
    animation: reducedMotion ? 0 : 150,
    ghostClass: draggingClass,
    delay: 150,
    delayOnTouchOnly: true,
    // the indexes count the items only, not other children (e.g. the hidden
    // inputs of `inputs_for`)
    onEnd: ({ item: node, oldDraggableIndex, newDraggableIndex }) => {
      if (oldDraggableIndex === newDraggableIndex) return

      const reordered = [...ids()]
      const [movedId] = reordered.splice(oldDraggableIndex, 1)
      reordered.splice(newDraggableIndex, 0, movedId)

      const rendered = [...items()]
      const following = rendered[oldDraggableIndex + 1]
      const preceding = rendered[oldDraggableIndex - 1]

      const restore = () => {
        if (following) list.insertBefore(node, following)
        else if (preceding) preceding.after(node)
      }

      onReorder(reordered, restore)
    },
  })
}
